/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from 'react';
import { Button, Table, Input, Form, Row, Col, Modal, message, Select, Radio } from 'antd';
import { services } from '@comall-backend-builder/core';
import { errorHandle } from '../../../../services';
import './index.less';
const api = services.api;

const SelectSknComponent: React.FC<any> = ({ form, visible, handleSelectSkn, selectId }) => {
    const [tableData, setTableData] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);
    const [selectedRowKeys, setSelectedRowKeys] = useState<any[]>([]);
    const [selectedRows, setSelectedRows] = useState<any[]>([]);
    const [total, setTotal] = useState<any>(0);
    const [pageNum, setPageNum] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(10);

    useEffect(() => {
        const defaultPage = 1;
        const defaultPageSize = 10;
        loadSknList(defaultPage, defaultPageSize);
    }, []);

    // 获取数据
    const loadSknList = (page: number, per_page: number) => {
        setLoading(true);
        const searchValue = { ...form.getFieldsValue() };
        searchValue.oldSkuCode = selectId;
        api.get(
            { ...searchValue, page, per_page },
            { apiPath: `/orderReplaceSkn/get_replace_product_list` }
        )
            .then((res: any) => {
                const { result, totalNum } = res;
                setTableData(result || []);
                setTotal(totalNum);
            })
            .catch(errorHandle)
            .finally(() => {
                setLoading(false);
            });
    };

    const getFields = () => {
        const { getFieldDecorator } = form;
        const children = [
            <Col span={12}>
                <Form.Item label={`搜索商品`} labelCol={{ span: 8 }}>
                    {getFieldDecorator('skuCode')(<Input placeholder="请输入sku/skn" />)}
                </Form.Item>
            </Col>,
        ];
        return children;
    };

    const handleSearch = (e: React.FormEvent) => {
        e.preventDefault();
        setPageNum(1);
        loadSknList(1, pageSize);
    };

    // 点击重置按钮
    const handleReset = () => {
        form.resetFields();
        setPageNum(1);
        loadSknList(1, pageSize);
    };

    const columns: any[] = [
        {
            title: 'SKU',
            dataIndex: 'sku',
            width: 160,
            align: 'center',
        },
        {
            title: 'SKN',
            dataIndex: 'skn',
            width: 120,
            align: 'center',
        },
        {
            title: '商品名称',
            dataIndex: 'showName',
            width: 160,
            align: 'center',
        },
        {
            title: '商品售价',
            dataIndex: 'price',
            width: 100,
            align: 'center',
        },
        {
            title: '库存位置',
            dataIndex: 'sourceShopName',
            width: 220,
            render: (_: any, record: any) => {
                return record.sourceShopCode && record.sourceShopName
                    ? `${record.sourceShopCode}-${record.sourceShopName}`
                    : '';
            },
            align: 'center',
        },
    ];

    const onShowSizeChange = (_current: any, size: any) => {
        setPageNum(1);
        setPageSize(size);
        loadSknList(1, size);
    };

    // 改变分页
    const handlePageChange = (current: number, size: number) => {
        setPageNum(current);
        setPageSize(size);
        loadSknList(current, size);
    };

    return (
        <div className="sknSubstitution-box">
            <Modal
                width={1100}
                centered
                visible={visible}
                title="可置换商品"
                onCancel={() => {
                    handleSelectSkn();
                }}
                footer={[
                    <Button
                        key="back"
                        onClick={() => {
                            handleSelectSkn();
                        }}
                    >
                        取消
                    </Button>,
                    <Button
                        key="submit"
                        type="primary"
                        loading={loading}
                        onClick={() => {
                            if (!selectedRowKeys.length) {
                                message.warning('请选择要置换的批次！');
                                return;
                            }
                            console.log(selectedRows, 'selectedRows');
                            const sku_code = selectedRows[0].sku;
                            api.get(
                                { oldSkuCode: selectId, skuCode: sku_code },
                                { apiPath: `/orderReplaceSkn/check_sku_replace_status` }
                            )
                                .then(() => {
                                    handleSelectSkn(selectedRows);
                                })
                                .catch(errorHandle);
                        }}
                    >
                        确定
                    </Button>,
                ]}
            >
                <Form
                    className="ant-advanced-search-form"
                    style={{ marginBottom: '6px' }}
                    onSubmit={handleSearch}
                >
                    <Row>
                        {getFields()}
                        <Col span={12} style={{ textAlign: 'right' }}>
                            <Button type="primary" htmlType="submit">
                                查询
                            </Button>
                            <Button style={{ marginLeft: 8 }} onClick={handleReset}>
                                重置
                            </Button>
                        </Col>
                    </Row>
                </Form>
                <Table
                    scroll={{ y: 360 }}
                    rowKey="id"
                    loading={loading}
                    columns={columns}
                    dataSource={tableData}
                    rowSelection={{
                        columnTitle: '选择',
                        type: 'radio',
                        selectedRowKeys,
                        onChange: (keys, rows) => {
                            setSelectedRowKeys(keys);
                            setSelectedRows(rows);
                        },
                    }}
                    pagination={{
                        current: pageNum, //当前页码
                        pageSize, // 每页数据条数
                        showSizeChanger: true,
                        showQuickJumper: false,
                        pageSizeOptions: ['10', '15', '20'],
                        total: total,
                        onShowSizeChange: onShowSizeChange,
                        onChange: handlePageChange,
                        showTotal: (total, range) => `第${range[0]}-${range[1]}条/总共${total}条`,
                    }}
                />
            </Modal>
        </div>
    );
};

export const SelectSkn = Form.create<any>()(SelectSknComponent);
export default SelectSkn;
